import { useCallback, useEffect, useState } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getRoot } from 'lexical';

export default function WordCount() {
  const [editor] = useLexicalComposerContext();
  const [wordCount, setWordCount] = useState(0);

  const calculateWordCount = useCallback(() => {
    editor.getEditorState().read(() => {
      const text = $getRoot().getTextContent();
      const trimmed = text.trim();
      if (!trimmed) {
        setWordCount(0);
        return;
      }
      setWordCount(trimmed.split(/\s+/).length);
    });
  }, [editor]);

  useEffect(() => {
    return editor.registerUpdateListener(() => {
      calculateWordCount();
    });
  }, [editor, calculateWordCount]);

  return (
    <div className="lexical-rich-text-editor__word-count">
      {wordCount} {wordCount === 1 ? 'word' : 'words'}
    </div>
  );
}
